import webui from "../app/InternalStateService";

export const loadComponent = async id => {
    let component = await getComponentModule(id);
    let obj = {};
    obj[id] = component.default;
    webui.addComponents(obj);
};

const getComponentModule = async id => {
    switch (id) {
        case "accordion":
            return await import(
                /* webpackChunkName: "webui.component.accordion" */ `./accordion/Accordion.js`
            );
        case "actionMenu":
            return await import(
                /* webpackChunkName: "webui.component.actionMenu" */ `./action-menu/ActionMenu.js`
            );
        case "badge":
            return await import(/* webpackChunkName: "webui.component.badge" */ `./badge/Badge.js`);
        case "banner":
            return await import(
                /* webpackChunkName: "webui.component.banner" */ `./banner/Banner.js`
            );
        case "base":
            return await import(
                /* webpackChunkName: "webui.component.base" */ `./base/BaseComponent.js`
            );
        case "baseHeading":
            return await import(
                /* webpackChunkName: "webui.component.baseHeading" */ `./heading/BaseHeading.js`
            );
        case "globalTheme":
            return await import(
                /* webpackChunkName: "webui.component.globalTheme" */ `./global-theme/GlobalTheme.js`
            );
        case "breadcrumb":
            return await import(
                /* webpackChunkName: "webui.component.breadcrumb" */ `./breadcrumbs/Breadcrumbs.js`
            );
        case "button":
            return await import(
                /* webpackChunkName: "webui.component.button" */ `./button/Button.js`
            );
        case "cardPanelContainer":
            return await import(
                /* webpackChunkName: "webui.component.cardPanelContainer" */ `./card-panel/CardPanelContainer.js`
            );
        case "carousel":
            return await import(
                /* webpackChunkName: "webui.component.carousel" */ `./carousel/Carousel.js`
            );
        case "chart":
            return await import(/* webpackChunkName: "webui.component.chart" */ `./chart/Chart.js`);
        case "checkbox":
            return await import(
                /* webpackChunkName: "webui.component.checkbox" */ `./checkbox/Checkbox.js`
            );
        case "checkboxGroup":
            return await import(
                /* webpackChunkName: "webui.component.checkboxGroup" */ `./checkbox-group/CheckboxGroup.js`
            );
        case "collection":
            return await import(
                /* webpackChunkName: "webui.component.collection" */ `./collection/BaseCollection.js`
            );
        case "container":
            return await import(
                /* webpackChunkName: "webui.component.container" */ `./container/Container.js`
            );
        case "uniqueContainer":
        case "smartContainer":
            return await import(
                /* webpackChunkName: "webui.component.smartContainer" */ `./container/SmartContainer.js`
            );
        case "controlMessages":
            return await import(
                /* webpackChunkName: "webui.component.controlMessages" */ `./control-messages/ControlMessages.js`
            );
        case "notification":
            return await import(
                /* webpackChunkName: "webui.component.notification" */ `./notification/NotificationContainer.js`
            );
        case "date":
        case "datepicker":
            return await import(
                /* webpackChunkName: "webui.component.datepicker" */ `./datepicker/Datepicker.js`
            );
        case "form":
            return await import(/* webpackChunkName: "webui.component.form" */ `./form/Form.js`);
        case "fileUpload":
            return await import(
                /* webpackChunkName: "webui.component.fileUpload" */ `./file-upload/FileUpload.js`
            );
        case "flowSingleStep":
            return await import(
                /* webpackChunkName: "webui.component.flow" */ `./flow-single-step/Flow.js`
            );
        case "flowHeader":
            return await import(
                /* webpackChunkName: "webui.component.flow" */ `./flow-single-step/FlowHeader.js`
            );
        case "flowFooter":
            return await import(
                /* webpackChunkName: "webui.component.flow" */ `./flow-single-step/FlowFooter.js`
            );
        case "flowStepProgress":
            return await import(
                /* webpackChunkName: "webui.component.flow" */ `./flow-single-step/FlowStepProgress.js`
            );
        case "stepLayout":
            return await import(
                /* webpackChunkName: "webui.component.flow" */ `./flow-single-step/StepLayout.js`
            );
        case "stepFooter":
            return await import(
                /* webpackChunkName: "webui.component.flow" */ `./flow-single-step/StepFooter.js`
            );
        case "step":
            return await import(
                /* webpackChunkName: "webui.component.flow" */ `./flow-single-step/Step.js`
            );
        case "stepProgress":
            return await import(
                /* webpackChunkName: "webui.component.stepProgress" */ `./step-progress/StepProgress.js`
            );
        case "gridOld":
            return await import(
                /* webpackChunkName: "webui.component.gridOld" */ `./grid-old/GridLayout.js`
            );
        case "grid":
            return await import(/* webpackChunkName: "webui.component.grid" */ `./grid/Grid.js`);
        case "globalLoading":
            return await import(
                /* webpackChunkName: "webui.component.globalLoading" */ `./loading-containers/GlobalLoading.js`
            );
        case "applicationLoading":
            return await import(
                /* webpackChunkName: "webui.component.applicationLoading" */ `./loading-containers/ApplicationLoading.js`
            );
        case "heading":
            return await import(
                /* webpackChunkName: "webui.component.heading" */ `./heading/Heading.js`
            );
        case "hyperlink":
            return await import(
                /* webpackChunkName: "webui.component.hyperlink" */ `./hyperlink/Hyperlink.js`
            );
        case "icon":
            return await import(/* webpackChunkName: "webui.component.icon" */ `./icon/Icon.js`);
        case "input":
            return await import(/* webpackChunkName: "webui.component.input" */ `./input/Input.js`);
        case "multiInput":
            return await import(
                /* webpackChunkName: "webui.component.multiInput" */ `./multiInput/MultiInput.js`
            );
        case "inputNumber":
            return await import(
                /* webpackChunkName: "webui.component.inputNumber" */ `./input-number/InputNumber.js`
            );
        case "inlineContainer":
            return await import(
                /* webpackChunkName: "webui.component.inlineContainer" */ `./inline-container/InlineContainer.js`
            );
        case "flexContainer":
            return await import(
                /* webpackChunkName: "webui.component.flexContainer" */ `./flex-container/FlexContainer.js`
            );
        case "itemPopover":
            return await import(
                /* webpackChunkName: "webui.component.itemPopover" */ `./item-popover/ItemPopover.js`
            );
        case "list":
            return await import(/* webpackChunkName: "webui.component.list" */ `./list/List.js`);
        case "selectableList":
            return await import(
                /* webpackChunkName: "webui.component.selectableList" */ `./list/SelectableList.js`
            );
        case "logo":
            return await import(/* webpackChunkName: "webui.component.logo" */ `./logo/Logo.js`);
        case "modalDialog":
            return await import(
                /* webpackChunkName: "webui.component.modalDialog" */ `./modal/Dialog.js`
            );
        case "modal":
            return await import(/* webpackChunkName: "webui.component.modal" */ `./modal/Modal.js`);
        case "maybe":
            return await import(
                /* webpackChunkName: "webui.component.maybe" */ `./maybe/MaybeContainer.js`
            );
        case "mixin":
            return await import(/* webpackChunkName: "webui.component.mixin" */ `./mixin/Mixin.js`);
        case "paginator":
            return await import(
                /* webpackChunkName: "webui.component.paginator" */ `./paginator/Paginator.js`
            );
        case "paragraph":
            return await import(
                /* webpackChunkName: "webui.component.paragraph" */ `./paragraph/Paragraph.js`
            );
        case "panel":
            return await import(/* webpackChunkName: "webui.component.panel" */ `./panel/Panel.js`);
        case "radioGroup":
            return await import(
                /* webpackChunkName: "webui.component.radioGroup" */ `./radio-group/RadioGroup.js`
            );
        case "rangeSlider":
            return await import(
                /* webpackChunkName: "webui.component.rangeSlider" */ `./range-slider/RangeSlider.js`
            );
        case "recaptcha2":
            return await import(
                /* webpackChunkName: "webui.component.recaptcha" */ `./recaptcha/Recaptcha2.js`
            );
        case "scrollbar":
            return await import(
                /* webpackChunkName: "webui.component.scrollbar" */ `./container/ScrollbarContainer.js`
            );
        case "scrollLoading":
            return await import(
                /* webpackChunkName: "webui.component.scrollLoading" */ `./container/ScrollLoading.js`
            );
        case "switcher":
            return await import(
                /* webpackChunkName: "webui.component.switcher" */ `./switcher/Switcher.js`
            );
        case "section":
            return await import(
                /* webpackChunkName: "webui.component.section" */ `./section/Section.js`
            );
        case "separator":
            return await import(
                /* webpackChunkName: "webui.component.separator" */ `./separator/Separator.js`
            );
        case "splitBox":
            return await import(
                /* webpackChunkName: "webui.component.splitBox" */ `./split-box/SplitBox.js`
            );
        case "select":
        case "dropdown":
            return await import(
                /* webpackChunkName: "webui.component.dropdown" */ `./dropdown/Dropdown.js`
            );
        case "simpleButton":
            return await import(
                /* webpackChunkName: "webui.component.simpleButton" */ `./button/SimpleButton.js`
            );
        case "sidebar":
            return await import(
                /* webpackChunkName: "webui.component.sidebar" */ `./sidebar/Sidebar.js`
            );
        case "static":
            return await import(
                /* webpackChunkName: "webui.component.static" */ `./static/Static.js`
            );
        case "outputText":
            return await import(
                /* webpackChunkName: "webui.component.outputText" */ `./output-text/OutputText.js`
            );
        case "outputBoolean":
            return await import(
                /* webpackChunkName: "webui.component.outputBoolean" */ `./output-text/OutputBoolean.js`
            );
        case "outputNumber":
            return await import(
                /* webpackChunkName: "webui.component.outputNumber" */ `./output-text/OutputNumber.js`
            );
        case "outputDate":
            return await import(
                /* webpackChunkName: "webui.component.outputDate" */ `./output-text/OutputDate.js`
            );
        case "plainText":
            return await import(
                /* webpackChunkName: "webui.component.plainText" */ `./output-text/PlainText.js`
            );
        case "table":
            return await import(/* webpackChunkName: "webui.component.table" */ `./table/Table.js`);
        case "textTableCell":
            return await import(
                /* webpackChunkName: "webui.component.textTableCell" */ `./table/DefaultTextTableHeaderCell.js`
            );
        case "textArea":
            return await import(
                /* webpackChunkName: "webui.component.textArea" */ `./text-area/TextArea.js`
            );
        case "tabs":
            return await import(/* webpackChunkName: "webui.component.tabs" */ `./tabs/Tabs.js`);
        case "tree":
            return await import(/* webpackChunkName: "webui.component.tree" */ `./tree/Tree.js`);
        case "treeNodeContent":
            return await import(
                /* webpackChunkName: "webui.component.treeNodeContent" */ `./tree/TreeNodeContent.js`
            );
        case "rightMenuNodeContent":
            return await import(
                /* webpackChunkName: "webui.component.rightMenuNodeContent" */ `./tree/RightMenuNodeContent.js`
            );
        case "thumbnail":
            return await import(
                /* webpackChunkName: "webui.component.thumbnail" */ `./thumbnail/Thumbnail.js`
            );
        case "widget":
            return await import(
                /* webpackChunkName: "webui.component.widget" */ `./widget-container/WidgetContainer.js`
            );
        case "widgetContainer":
            return await import(
                /* webpackChunkName: "webui.component.widgetContainer" */ `../app/WidgetDashboard.js`
            );
        case "widgetPortal":
            return await import(
                /* webpackChunkName: "webui.component.widgetPortal" */ `./widget-container/WidgetPortal.js`
            );
        case "googleMap":
            return await import(
                /* webpackChunkName: "webui.component.googleMap" */ `./google-map/GoogleMap.js`
            );
        case "googleMapLoading":
        case "widgetLoading":
            return await import(
                /* webpackChunkName: "webui.component.widgetLoading" */ `./loading-containers/WidgetLoading.js`
            );
        case "menu":
            return await import(/* webpackChunkName: "webui.component.menu" */ `./menu/Menu.js`);
        case "loadingAnimationContainer":
            return await import(
                /* webpackChunkName: "webui.component.loadingAnimationContainer" */ `./loading-containers/LoadingAnimationContainer.js`
            );
        case "title":
            return await import(/* webpackChunkName: "webui.component.title" */ `./title/Title.js`);
        case "preloader":
            return await import(
                /* webpackChunkName: "webui.component.preloader" */ `@tinqin/tinqin-ui-components/src/preloader/Preloader`
            );
        case "portalContainer":
            return await import(
                /* webpackChunkName: "webui.component.portalContainer" */ `./portal-container/PortalContainer.js`
            );

        default:
            return false;
    }
};

// export default { loadAllComponents}

// const list = [
//     "actionMenu",
//     "badge",
//     "banner",
//      ...
// ];
// const generateCode = list => {
//     let template = `case "{name}":
//     return await import(
//         /* webpackChunkName: "webui.component.{name}" */ \`./{name}/{name}.js\`
//     );
//     `;
//     let result = "";
//     list.forEach(name => {
//         result += template.replaceAll("{name}", name);
//     });
//     console.log(result);
// };
// generateCode(list);
